const GLOBAL_COOLDOWN_KEY = '__global__';

const cooldownUntilByKey = new Map<string, number>();

export function setRateLimitCooldown(seconds: number, key = GLOBAL_COOLDOWN_KEY): void {
  const waitMs = Math.max(1, Number(seconds) || 60) * 1000;
  cooldownUntilByKey.set(key, Date.now() + waitMs);
}

export function isRateLimitBlocked(key = GLOBAL_COOLDOWN_KEY): boolean {
  const until = cooldownUntilByKey.get(key);
  if (!until) return false;
  if (Date.now() < until) return true;
  cooldownUntilByKey.delete(key);
  return false;
}

export function getRateLimitRemainingSeconds(key = GLOBAL_COOLDOWN_KEY): number {
  const until = cooldownUntilByKey.get(key);
  if (!until) return 0;
  const diff = Math.ceil((until - Date.now()) / 1000);
  if (diff <= 0) {
    cooldownUntilByKey.delete(key);
    return 0;
  }
  return diff;
}

export function clearRateLimitCooldown(key?: string): void {
  if (key == null) {
    cooldownUntilByKey.clear();
    return;
  }
  cooldownUntilByKey.delete(key);
}
